export { default } from './defaultFooter';